<template>
  <div class="account-dropdown" style="margin-top: -3px;">
    <b-nav-item-dropdown right v-b-tooltip.hover>
      <Alerts />
      <template slot="button-content">
        <span>
          Settings <i class="fa fa-cog" aria-hidden="true"></i>
        </span>
        <!-- <svg
          class="icon"
          version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="28px" height="28px" viewBox="0 0 32 32" style="fill: #fff; enable-background:new 0 0 32 32;" xml:space="preserve">
          <g>
            <g id="User">
              <g>
                <path d="M16,22c4.963,0,9-4.936,9-11c0-6.064-4.038-11-9-11c-2.447,0-4.734,1.174-6.438,3.305C7.909,5.37,7,8.104,7,11.001
                  C7,17.064,11.037,22,16,22z M16,2.001c3.859,0,7,4.037,7,9c0,4.962-3.141,9-7,9c-3.859,0-7-4.038-7.001-9
                  C8.999,6.038,12.14,2.001,16,2.001z M23,20c-0.553,0-1,0.447-1,1s0.447,1,1,1c3.859,0,7,3.141,7,7c0,0.551-0.449,1-1,1H3
                  c-0.551,0-1-0.449-1-1c0-3.859,3.141-7,7-7c0.553,0,1-0.447,1-1s-0.447-1-1-1c-4.963,0-9,4.037-9,9c0,1.654,1.346,3,3,3h26
                  c1.654,0,3-1.346,3-3C32,24.038,27.963,20,23,20z"/>
              </g>
            </g>
          </g>
        </svg> -->
      </template>
      <b-dropdown-text class="h6 text-center">{{ employee_name || user.name }}</b-dropdown-text>
      <b-dropdown-item to="/my-account">
        <b-img src="/images/icon-account2.png" width="20" style="margin-left: -10px; margin-right: 5px;" /> My Account
      </b-dropdown-item>
      <b-dropdown-item @click.prevent="e => onClickScanForm()">
        <b-img src="/images/icons/scan.png" width="20" style="margin-left: -10px; margin-right: 5px;" /> SCAN Form
      </b-dropdown-item>
      <b-dropdown-item to="/help/customer-support">
        <b-img src="/images/icons/contact.png" width="20" style="margin-left: -10px; margin-right: 5px;" /> Contact Us
      </b-dropdown-item>
      <b-dropdown-item @click.prevent="logout">
        <b-img src="/images/icons/logout.png" width="20" style="margin-left: -10px; margin-right: 5px;" />
        Log Out
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <scan-form ref="scanFormModal" v-if="showScanForm" :scanforms="scanforms"></scan-form>
  </div>
</template>
<style lang="scss" scoped>
.icon {
  width: 1.25rem;
  //margin-left: -10px;
  //margin-right: 10px;
}

.dropdown-item {

  &:active,
  &:focus {
    background-color: #f9f9f9;
  }

  i {
    color: #9fabb8;
  }
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import ScanForm from "../Modals/ScanForm";

export default {
  name: "header-dropdown-accnt",
  components: { ScanForm },
  data() {
    return {
      userEmail: '',
      userName: '',
      showScanForm: false,
      scanforms: [],
    };
  },
  async mounted() {
    console.log('header mounted');
    try {
      const { data: { name } } = await axios.get("/users?ajax=true");
      this.userName = name;
      await this.getScanForms();
    } catch (e) {
      console.log("error", e);
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee_name: "getEmployeeName",
    })
  },
  methods: {
    ...mapActions(["addPrintJob"]),
    logout() {
      console.log("LOGOUT AGAIN!")
      axios
        .post("/logout")
        .then(function (response) {
          // localStorage.clear();
          localStorage.removeItem('shipper');
          window.location = "/";
        })
        .catch(function (error) {
          window.location = "/";
        });
    },
    async getScanForms() {
      try {
        console.log('getting scanforms');
        const { data } = await axios.get('/scan-forms');
        this.scanforms = data;
      } catch (e) {
        console.error(e);
      }
    },
    async onClickScanForm() {
      this.showScanForm = true;
      await this.getScanForms();
      this.$nextTick(() => {
        this.$refs.scanFormModal.show();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header/HeaderDropdownAccnt.vue